"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var slate_react_1 = require("slate-react");
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var EditorBlockQuote_1 = __importDefault(require("../EditorBlockQuote"));
var EditorEmbedMedia_1 = __importDefault(require("../EditorEmbedMedia"));
var EditorEmbeddedMedia_1 = __importDefault(require("../EditorEmbeddedMedia"));
var EditorUploadImage_1 = __importDefault(require("../EditorUploadImage"));
var EditorUploadedImage_1 = __importDefault(require("../EditorUploadedImage"));
var EditorLinkedImage_1 = __importDefault(require("../EditorLinkedImage"));
var EditorInsertImageFromMobile_1 = __importDefault(require("../EditorInsertImageFromMobile"));
var EditorTexElement_1 = __importDefault(require("../EditorTexElement"));
var EditorLinkElement_1 = __importDefault(require("../EditorLinkElement"));
var EditorElement = function (_a) {
    var attributes = _a.attributes, children = _a.children, element = _a.element;
    var editor = slate_react_1.useSlate();
    editor.isVoid = function (elem) {
        return [
            'media',
            'insert-image-upload',
            'image-uploaded',
            'image-linked',
            'insert-image-phone',
        ].includes(elem.type);
    };
    switch (element.type) {
        case 'block-quote':
            return react_1.default.createElement(EditorBlockQuote_1.default, { attributes: attributes }, children);
        case 'bulleted-list':
            return react_1.default.createElement("ul", __assign({}, attributes), children);
        case 'list-item':
            return react_1.default.createElement("li", __assign({}, attributes), children);
        case 'title':
            return (react_1.default.createElement(Typography_1.default, __assign({ gutterBottom: true, variant: "h2", component: "h1" }, attributes), children));
        case 'heading-one':
            return (react_1.default.createElement(Typography_1.default, __assign({ gutterBottom: true, variant: "h2", component: "h1" }, attributes), children));
        case 'heading-two':
            return (react_1.default.createElement(Typography_1.default, __assign({ gutterBottom: true, variant: "h3", component: "h2" }, attributes), children));
        case 'numbered-list':
            return react_1.default.createElement("ol", __assign({}, attributes), children);
        case 'code':
            return react_1.default.createElement("pre", __assign({}, attributes), children);
        case 'embed-media':
            return (react_1.default.createElement(EditorEmbedMedia_1.default, { attributes: attributes, description: "Supported sources: YouTube, Vimeo, DailyMotion, SoundCloud, Mixcloud", type: "media", element: element }, children));
        case 'insert-image-link':
            return (react_1.default.createElement(EditorEmbedMedia_1.default, { attributes: attributes, description: "Supported images: JPEG, PNG, GIF", type: "image-linked", element: element }, children));
        case 'media':
            return (react_1.default.createElement(EditorEmbeddedMedia_1.default, { attributes: attributes, url: element.children[0].text }, children));
        case 'insert-image-upload':
            return (react_1.default.createElement(EditorUploadImage_1.default, { attributes: attributes, element: element, file: element.file }, children));
        case 'insert-image-phone':
            return (react_1.default.createElement(EditorInsertImageFromMobile_1.default, { element: element, attributes: attributes }, children));
        case 'image-uploaded':
            return (react_1.default.createElement(EditorUploadedImage_1.default, { attributes: attributes, dimensions: element.dimensions, element: element, url: element.url, id: element.id }, children));
        case 'image-linked':
            return (react_1.default.createElement(EditorLinkedImage_1.default, { attributes: attributes, url: element.url || element.children[0].text }, children));
        case 'tex':
            return react_1.default.createElement(EditorTexElement_1.default, { attributes: attributes }, children);
        case 'link':
            return (react_1.default.createElement(EditorLinkElement_1.default, { url: element.url, attributes: attributes }, children));
        default:
            return (react_1.default.createElement(Typography_1.default, __assign({ paragraph: true }, attributes), children));
    }
};
exports.default = EditorElement;
//# sourceMappingURL=EditorElement.js.map